<template>
    <div>
        <div id="catalog">
            <div class="container">
                <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

                <div class="row">
                    <div class="d-none d-xl-block col-xl-3">
                        <catalog-categories></catalog-categories>
                    </div>
                    <div class="col-xl-9">
                        <h1 class="mb-24">Продажа</h1>
                        <div class="row catalog-row mb-32" v-if="filter.state.products && filter.state.products.length > 0">
                            <div class="col-6 col-sm-4 col-lg-3 mb-10" v-for="item in filter.state.products">
                                <card-sale :item="item"></card-sale>
                            </div>
                        </div>
                        <div v-if="filter.state.products && filter.state.products.length < 1">
                            <span class="h5">К сожалению, на текущий момент нет товаров на акции.</span>
                        </div>
                        <div  v-if="filter.state.products && filter.state.count > 16">
                            <b-pagination-nav
                                @page-click="pageClick"
                                :link-gen="linkGen"
                                :number-of-pages="totalRows"
                                use-router>
                            </b-pagination-nav>
                        </div>

                        <div v-if="filter.state.loading" class="loading-box">
                            <b-spinner></b-spinner>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import filter from "../../../services/filter";

    export default {
        data() {
            return {
                filter: filter,
                perPage: 20,
                currentPage: 0,

                breadcrumb: null,
                seo_text: null
            }
        },
        computed: {
            totalRows() {
                return Math.ceil(this.filter.state.count / this.perPage)
            },
        },
        watch: {
            $route() {
                this.loading = true;
                if (this.$route.query.page) this.filter.filter.page = this.$route.query.page;
                else this.filter.filter.page = 1;
                this.init();
            },
        },

        mounted() {
            if (this.$route.query.page) this.filter.filter.page = this.$route.query.page;
            else this.filter.filter.page = 1;
            this.init();
        },

        methods: {
            linkGen(pageNum) {
                return pageNum == 1 ? '?' : `?page=${pageNum}`;
            },
            pageClick(bvEvent, page) {
                this.page = page;
            },

            init() {
                this.filter.state.loading = true;
                this.filter.filter.url = this.$route.path;
                this.filter.getSaleProducts(this.$route.path);

                this.getSeoInfo('sale', null, 'Продажа видеокамер, фотоаппаратов, звукового и светового оборудования в Минске "MRental"',
                    'Продажа видеокамер, фотоаппаратов, звукового и светового оборудования в Минске "MRental"');
            },
            getSeoInfo(path, type, titleDefault, descDefault){
                let url = '/api/seo';

                let params = {
                    url: path,
                    type: type
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo;
                        this.seo_text = seoInfo.seo_text;

                        this.seo_name = seoInfo?.seo_h1 && seoInfo.seo_h1  ? seoInfo.seo_h1 : seoInfo.name;

                        document.title = seoInfo?.seo_title && seoInfo.seo_title  ? seoInfo.seo_title : titleDefault;
                        let desc = seoInfo?.seo_desc && seoInfo.seo_desc ? seoInfo.seo_desc : descDefault;
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                        this.setDocTitleAndDescr();
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            },
            setDocTitleAndDescr() {
                if (this.filter.filter.page > 1) {
                    let title = document.title;
                    let description = document.querySelector('meta[name="description"]').getAttribute("content");
                    title += ', Cтраница -' + this.filter.filter.page;
                    description += ', Cтраница -' + this.filter.filter.page
                    console.log(title, 'title');
                    console.log(description, 'description')
                    document.title = title;
                    document.querySelector('meta[name="description"]').setAttribute("content", description);
                    document.querySelector('meta[name="robots"]').setAttribute("content",  'noindex, follow');
                } else {
                    document.querySelector('meta[name="robots"]').setAttribute("content",  'index, follow');
                }
            },
            getBreadcrumb() {
                this.breadcrumb = [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: "Продажа",
                        active: true
                    }
                ]
            }
        }
    }
</script>

